import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { IPracticeSetupStepDefinition } from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

export const practiceInfoStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.PracticeInfo,
  category: PracticeSetupStepCategory.GeneralPracticeSettings,
  title: `Approve Your Practice's Settings`,
  description: initRawSchema(
    `Configure your practice's basic information including address, email, phone number, and timezone settings. All relevant fields need to be completed before this page can be saved. If you have more than one practice, repeat this step for each of them.`
  ),
  dependsOn: [],
  getRoute: (_brand, practice) =>
    `settings/practice/${practice.ref.id}/general`,
  validate$: (practice$, _step, _options) => {
    return practice$.pipe(
      map((practice) => {
        const missingFields: string[] = [];

        if (!practice.metadata?.address?.isVerified) {
          missingFields.push('verified address');
        }
        if (!practice.email.trim()) {
          missingFields.push('email');
        }
        if (!practice.phone.trim()) {
          missingFields.push('phone');
        }
        if (!practice.settings?.timezone) {
          missingFields.push('timezone');
        }

        if (missingFields.length > 0) {
          return {
            valid: false,
            reason: `Practice is missing required fields: ${missingFields.join(
              ', '
            )}`,
          };
        }

        return { valid: true };
      })
    );
  },
  pageVisitTracking: {
    routes: ['settings/practice/{practiceId}/general'],
    validationMode: 'any',
  },
};
